// extracted by mini-css-extract-plugin
export default {"page":"Cupons_Desconto_page__njty7","containerImg":"Cupons_Desconto_containerImg__i5xbH","vazio":"Cupons_Desconto_vazio__DS6Vr","vazioBusca":"Cupons_Desconto_vazioBusca__SKuC-"};